/** Ende eines AVM-Hinweises, nach dem ein "/" als Trenner gilt: Satzzeichen oder der Warn-Marker "+++". */
const MESSAGE_END = /(?:[.!?]|\+{3})$/;

/**
 * Split an AVM multi-message string (e.g. "info_info", "info_hint") into its messages.
 * The AVM appends every message as "<Satz>. /" – but "/" also occurs inside a message ("€/t", which the
 * AVM normalizes to "€ / t", "Nah-/Fernwärme", "Nettogrundfläche / Nutzfläche"). So a "/" only separates
 * when the text before it ends a message (".", "!", "?", "+++") or an empty section follows ("/ /", trailing
 * "/"); otherwise it stays in the text – without the spaces the AVM put around it ("€/t", "Nah-/Fernwärme").
 * Each item is trimmed, and empty items are filtered out.
 * @param input input string (e.g. " Message 1. / CO₂-Preis 55 € / t, Ansatz nach Vorsichtsprinzip. /")
 * @return split string (as fallback: empty array) (e.g. ["Message 1.", "CO₂-Preis 55 €/t, Ansatz nach Vorsichtsprinzip."])
 */
export function splitMultilineString(input: string | null | undefined): string[] {
    if (!input || typeof input !== "string") return [];
    const items: string[] = [];
    let current = "";
    for (const segment of input.split("/")) {
        const pending = current.trim();
        if (pending === "") {
            current = segment;
        } else if (MESSAGE_END.test(pending) || segment.trim() === "") {
            // Satzende oder leerer Abschnitt ("/ /", "/" am Ende): hier endet die Meldung
            items.push(pending);
            current = segment;
        } else {
            current = `${current.trimEnd()}/${segment.trimStart()}`;
        }
    }
    const last = current.trim();
    if (last) items.push(last);
    return items;
}
